import { ColorLens, StarBorder, ThreeDRotation } from "@mui/icons-material";

export const IconOptions = [
  {
    value: 2,
    iconText: {
      icon: <ThreeDRotation />,
      text: "3D",
    },
  },
  {
    value: 1,
    iconText: {
      icon: <StarBorder />,
      text: "خطی",
    },
  },
  {
    value: 3,
    iconText: {
      icon: <ColorLens />,
      text: "رنگی",
    },
  },
];
